<template>
  <g>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2645,12.3374l-1.848,0.765l0.766,1.848l1.847-0.7659L12.2645,12.3374z
    M7.0545,14.0714l-1.848,0.7661l0.766,1.847l1.847-0.764L7.0545,14.0714z M15.2325,16.0175l-1.848,0.765l0.765,1.848l1.848-0.765
    L15.2325,16.0175z"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1349,5.4088c0.255,0.105,0.376,0.398,0.27,0.6529l-1.9134,4.6188
    c-0.079,0.1929-0.266,0.309-0.462,0.309c-0.064,0-0.129-0.012-0.191-0.0381c-0.255-0.1059-0.376-0.3979-0.271-0.6529l1.9134-4.6196
    C14.5869,5.4228,14.8809,5.3008,15.1349,5.4088z M8.8886,8.337c0.106-0.255,0.4-0.3772,0.653-0.27
    c0.255,0.105,0.376,0.3979,0.271,0.6529l-1.5311,3.6955c-0.079,0.192-0.266,0.3081-0.462,0.3081c-0.064,0-0.129-0.0111-0.191-0.0381
    c-0.255-0.105-0.376-0.3979-0.271-0.6529L8.8886,8.337z M17.8316,8.4339c0.105-0.255,0.399-0.3769,0.653-0.27
    c0.255,0.105,0.376,0.3981,0.271,0.6531l-2.2961,5.5435c-0.08,0.1931-0.266,0.309-0.462,0.309c-0.064,0-0.129-0.012-0.191-0.038
    c-0.255-0.1061-0.376-0.399-0.271-0.654L17.8316,8.4339z"/>  
  </g>
</template>

<script>
export default {
  name: 'IcePelletsLight'
}
</script>